import ListItem from '@mui/material/ListItem';
import { FC } from 'react';
import { IEmailTemplate } from 'src/redux/services/settings';
import { CustomTypography } from '../../custom/CustomTypography';
import { IconWithTooltip } from '../../shared/IconWithTooltip';
import styles from './EmailTemplate.module.css';

type EmailTemplateProps = {
  template: IEmailTemplate;
  onClick: () => void;
};

export const EmailTemplate: FC<EmailTemplateProps> = ({
  template: { title, action } = {},
  onClick,
}) => {
  return (
    <ListItem data-id="email-template-item" className={styles.listItem}>
      <div className={styles.container}>
        <div className={styles.head}>
          <CustomTypography className="text-14">{title}</CustomTypography>
          <CustomTypography className="text-12" color="grey">
            {action}
          </CustomTypography>
        </div>
        <IconWithTooltip iconType="edit" onClick={onClick} />
      </div>
    </ListItem>
  );
};
